class ShopTheLook extends HTMLElement {
  constructor() {
    super();
    this.scrollElement = this.querySelector('.shop-the-look__scroll');
    this.scrollMoreShadowElement = this.querySelector('.shop-the-look__scroll-shadow');
    this.productItems = this.querySelectorAll('.shop-the-look__product-item');

    this.updateScrollHeight();
    this.addEventListeners();
    this.createFancySelect();
    this.syncSelectsAndRadios();
  }

  addEventListeners() {
    window.addEventListener('resize', this.updateScrollHeight.bind(this));
    if (this.scrollElement && this.scrollMoreShadowElement) {
      this.scrollElement.addEventListener('scroll', this.handleScroll.bind(this));
    }
  }

  createFancySelect() {
    this.querySelectorAll('#shopTheLookSelect').forEach(select => {
      $(select).niceSelect();
    });
  }

  updateScrollHeight() {
    if (!this.scrollElement) return;

    if (window.innerWidth > 1024 && this.productItems.length >= 2) {
      const firstItemHeight = this.productItems[0].offsetHeight;
      const secondItemHeight = this.productItems[1].offsetHeight;
      const combinedHeight = firstItemHeight + secondItemHeight + 22;
      this.scrollElement.style.maxHeight = `${combinedHeight}px`;
    } else {
      this.scrollElement.style.maxHeight = '';
    }
  }

  handleScroll() {
    const { scrollTop, clientHeight, scrollHeight } = this.scrollElement;
    const isNearBottom = scrollTop + clientHeight >= scrollHeight - 100;
    this.updateScrollMoreShadow(isNearBottom);
  }

  updateScrollMoreShadow(isNearBottom) {
    this.scrollMoreShadowElement.style.opacity = isNearBottom ? 0 : 1;
  }

  syncSelectsAndRadios() {
    this.productItems.forEach(productItem => {
      const selectElement = productItem.querySelector('#shopTheLookSelect');
      const radioElements = productItem.querySelectorAll('.shop-the-look__variant-option input[type="radio"]');
      const customSelectElement = productItem.querySelector('.nice-select');

      if (selectElement) {
        selectElement.addEventListener('change', this.handleSelectChange.bind(this, radioElements));
      }

      if (customSelectElement) {
        customSelectElement.addEventListener('click', this.handleCustomSelectClick.bind(this, customSelectElement, radioElements));
      }

      radioElements.forEach(radio => {
        radio.addEventListener('change', this.handleRadioChange.bind(this, selectElement));
      });
    });
  }

  handleSelectChange(radioElements, event) {
    const selectedValue = event.target.value;
    this.updateRadioButtons(radioElements, selectedValue);
  }

  handleCustomSelectClick(customSelectElement, radioElements) {
    setTimeout(() => { // We need to give it a small timeout because the library can take a bit to update the selected option and we need to fetch the data after it's updated
      const selectedOption = customSelectElement.querySelector('.option.selected');
      if (selectedOption) {
        const selectedValue = selectedOption.getAttribute('data-value');
        this.updateRadioButtons(radioElements, selectedValue);
      }
    }, 200);
  }

  handleRadioChange(selectElement, event) {
    const selectedValue = event.target.value;
    if (selectElement) {
      selectElement.value = selectedValue;
      $(selectElement).niceSelect('update'); // using jQuery as this is a dependency of the library
    }
  }

  updateRadioButtons(radioElements, selectedValue) {
    radioElements.forEach(radio => {
      radio.checked = radio.value === selectedValue;
    });
  }
}

if (!customElements.get("shop-the-look")) {
  customElements.define("shop-the-look", ShopTheLook);
}